import { useEffect } from 'react';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { getHasFetchedQuizQuestions } from '@selectors/quizTaking';
import useFailedAPIQueue from '@cont/Quiz/Taking/Common/useFailedAPIQueue';
import { useRouter } from 'next/router';

const useLanding = () => {
  const {
    query: { quizUID }
  } = useRouter();

  const hasFetchedQuizQuestions = useSelectorWithShallowEqual(
    getHasFetchedQuizQuestions(quizUID)
  );

  const { startProcessingFailedAPIS } = useFailedAPIQueue();

  useEffect(() => {
    startProcessingFailedAPIS();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    hasFetchedQuizQuestions
  };
};

export default useLanding;
